import { render, staticRenderFns } from "./ModalSelectOrder.vue?vue&type=template&id=72828f60&"
import script from "./ModalSelectOrder.vue?vue&type=script&lang=js&"
export * from "./ModalSelectOrder.vue?vue&type=script&lang=js&"
import style0 from "./ModalSelectOrder.vue?vue&type=style&index=0&id=72828f60&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports